// extracted by mini-css-extract-plugin
export var section = "Docente-module--section--4El-A";
export var videoContainer = "Docente-module--video-container--3Oa89";